export default ([
  {
    label   : 'G',
    itemKey : 'obscoreG',
  },
  {
    label   : 'P',
    itemKey : 'obscoreP',
  },
  {
    label   : 'FT',
    itemKey : 'obscoreFT',
  },
  {
    label   : 'Pr',
    itemKey : 'obscorePr',
  },
  {
    label   : 'Ab',
    itemKey : 'obscoreAb',
  },
  {
    label   : 'LB',
    itemKey : 'obscoreLB',
  },
])